export const resolveDestination = (path: string, role: string): string => {
  const segments = path.split("/");
  const [entityType, ...rest] = segments;

  const routes: Record<string, Record<string, string>> = {
    member: {
      admin: "/admin/members",
      practice_manager: "/location/:locationId/practice-members",
      default: "/location/:locationId/practice-members",
    },
    booking: {
      admin: "/admin/bookings",
      practice_manager: "/location/:locationId/practice-bookings",
      default: "/location/:locationId/practice-bookings",
    },
  };

  const roleRoutes = routes[entityType];
  if (!roleRoutes) return "/404";

  const basePath = roleRoutes[role] || roleRoutes.default || "/404";
  return `${basePath}/${rest.join("/")}`;
};
